<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="forecast-breakdown-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">
              &times;
            </span>
          </button>

          <h4 class="modal-title">
            Breakdown
          </h4>
        </div>

        <div class="modal-body">
          <table class="table table-striped">
            <thead>
            <tr>
              <th class="col-xs-6">
                Company
              </th>

              <th class="col-xs-6">
                Portal
              </th>

              <th class="col-xs-6">
                Type
              </th>

              <th class="col-xs-6 text-right">
                Value
              </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="row in rowsInPage">
              <td class="table__ellipsis">
                <router-link :to="'/companies/' + row.company_id + '/subscriptions/' + row.subscription_id" data-dismiss="modal">
                  {{ row.company_name }}
                </router-link>
              </td>

              <td class="table__ellipsis">
                <router-link :to="'/portals/' + row.portal_id" data-dismiss="modal">
                  {{ row.portal_name }}
                </router-link>
              </td>

              <td>
                <span v-if="row.category === 'existing'" class="label label-success" style="background-color: #62d26f">
                  Existing
                </span>

                <span v-if="row.category === 'forecast'" class="label label-success" style="background-color: #eec300">
                  Forecast
                </span>

                <span v-if="row.category === 'new'" class="label label-success" style="background-color: #20aaea">
                  New
                </span>
              </td>

              <td class="text-right">
                {{ row.value | price }}
              </td>
            </tr>
            </tbody>
          </table>

          <SimplePager :current-page="page" :last-page="lastPage" @navigate="page = $event"/>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimplePager from '../../Lists/SimplePager'

export default {
  components: {SimplePager},
  props: {
    rows: {
      required: true
    }
  },

  data() {
    return {
      page: 1
    }
  },

  computed: {
    rowsInPage() {
      return this.rows.slice(10 * (this.page - 1), 10 * this.page)
    },

    lastPage() {
      return Math.ceil(this.rows.length / 10)
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    reset() {
      this.page = 1
    }
  }
}
</script>
